import { z } from "zod";

const onPremisePaymentTypes = [
    "on_premise_pay_later",
    "on_premise_paid",
    "pay_request",
    "tokenized_card",
] as const;
const onPremisePaymentTypeZodEnum = z.enum(onPremisePaymentTypes);
type OnPremisePaymentType = z.infer<typeof onPremisePaymentTypeZodEnum>;

export type { OnPremisePaymentType };
export { onPremisePaymentTypeZodEnum, onPremisePaymentTypes };
